class AdpSearchInputController {
  constructor() {
  }
}

export default AdpSearchInputController;



// WEBPACK FOOTER //
// ./src/app/components/adpSearchInput/adpSearchInput.controller.js